import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import PrepaidProgramDetailsFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/prepaid/prepaidProgramDetails/PrepaidProgramDetailsFormHandle';
import AnonymousCardsFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/prepaid/anonymousCards/AnonymousCardsFormHandle';
import RecordsFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/prepaid/records/RecordsFormHandle';
import CardByPrepaidAndStatusFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/prepaid/cardByPrepaidAndStatus/CardByPrepaidAndStatusFormHandle';

const Prepaid = () => {
  return (
    <div>
      <CC.Text fontSize={20} fontWeight="bold" mb="4">
      Programme prépayé 
      </CC.Text>
      
    <CC.Tabs>
      <div style={{overflowX: "auto"}}>
      <CC.TabList>
        <CC.Tab minWidth={'fit-content'}>Detail Programme prépayé</CC.Tab>
        <CC.Tab minWidth={'fit-content'}>Cartes Anonymes</CC.Tab>
        <CC.Tab minWidth={'fit-content'}>Relevés porteurs</CC.Tab>
        <CC.Tab minWidth={'fit-content'}>Cartes par prépayé et statut</CC.Tab>
      </CC.TabList>
      </div>

      <CC.TabPanels>
        <CC.TabPanel>
          <PrepaidProgramDetailsFormHandle />
        </CC.TabPanel>
        <CC.TabPanel>
          <AnonymousCardsFormHandle />
        </CC.TabPanel>
        <CC.TabPanel>
          <RecordsFormHandle />
        </CC.TabPanel>
        <CC.TabPanel>
          <CardByPrepaidAndStatusFormHandle />
        </CC.TabPanel>
      </CC.TabPanels>
    </CC.Tabs>

    </div>
  )
}

export default Prepaid;